// extracted by mini-css-extract-plugin
export default {"page":"styles_page__gSNDu","filters":"styles_filters__4oTeU","search":"styles_search__mtg5N"};